/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { PaymentServiceProvider } from "./PaymentServiceProvider";
import * as t from "io-ts";

// required attributes
const PaymentServiceProvidersR = t.interface({
  page_info: PageInfo,

  payment_service_providers: t.readonlyArray(
    PaymentServiceProvider,
    "array of PaymentServiceProvider"
  )
});

// optional attributes
const PaymentServiceProvidersO = t.partial({});

export const PaymentServiceProviders = t.intersection(
  [PaymentServiceProvidersR, PaymentServiceProvidersO],
  "PaymentServiceProviders"
);

export type PaymentServiceProviders = t.TypeOf<typeof PaymentServiceProviders>;
